import { ChangeDetectorRef, Component } from '@angular/core';
import { Inspection } from '../../../shared/models/index';
import { PluginComponent } from '../../plugin.component';

@Component({
    templateUrl: './equipment-info.component.html',
    standalone: false
})
export class InstallationEquipmentInfoPluginComponent {
  inspection: Inspection;
  machine: any[];
  public config: any;
  public editRoute = ['installation', 'equipmentinfo', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.inspection = inspection;
    this.machine =
      this.inspection.data != null && this.inspection.data.machine != null ? this.inspection.data.machine : null;
    if (this.machine && !(this.machine instanceof Array)) {
      this.machine = [this.machine];
    }
    this.cdRef.detectChanges();
  }
}
PluginComponent.plugins['installationequipmentinfo'] = InstallationEquipmentInfoPluginComponent;
